// profile/getters.ts
import { GetterTree } from 'vuex';
import {RootState, Lookup, LookupIcon, LookupDistance} from '../types';

import * as _ from 'lodash';
import {User} from 'firebase';


import Vue from 'vue';
import {RateState} from './types';

export const getters: GetterTree<RateState, RootState> = {

};
